import FooterBlurb from './FooterBlurb';

export default FooterBlurb;
